package com.shadowings.gero.domain.usecase

import com.shadowings.gero.domain.model.GameConstants
import com.shadowings.gero.domain.repository.UserDataRepository
import com.shadowings.gero.presentation.widget.notifyStrikeWidgetDataChanged
import com.shadowings.gero.util.currentDateAsInt
import com.shadowings.gero.util.dateIntToEpochDays
import kotlinx.coroutines.flow.first

/**
 * Gestisce la verifica dello streak e il riscatto del bonus giornaliero.
 */
class CheckDailyBonusUseCase(
    private val userDataRepository: UserDataRepository,
) {
    /**
     * Resetta lo strike a 0 se l'ultimo quiz completato è antecedente a ieri.
     */
    suspend fun checkStreakReset() {
        val todayDate = currentDateAsInt()
        val userData = userDataRepository.userData.first()

        if (userData.lastQuizDate > 0) {
            val daysDiff = dateIntToEpochDays(todayDate) - dateIntToEpochDays(userData.lastQuizDate)
            if (daysDiff > 1) {
                userDataRepository.setStrike(0)
            }
        }
    }

    /**
     * Riscattato alla conferma del popup giornaliero.
     * Se per oggi è già stato aperto/riscosso, ignora (idempotente).
     */
    suspend fun claimDailyBonus(isFullVersionUnlocked: Boolean = false, force: Boolean = false): Boolean {
        val todayDate = currentDateAsInt()
        val userData = userDataRepository.userData.first()

        if (!force && todayDate <= userData.lastOpenDate) {
            return false
        }

        if (!isFullVersionUnlocked) {
            userDataRepository.addHearts(GameConstants.DAILY_BONUS_HEARTS)
        }
        userDataRepository.setLastOpenDate(todayDate)
        notifyStrikeWidgetDataChanged()
        return true
    }

    suspend operator fun invoke() {
        checkStreakReset()
    }
}
